/**
 * @generated SignedSource<<850d714a842627ae91799c38b4a7657a>>
 * @relayHash e73dee74419da4096b72e089a76cdee3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6a51c65705334771c21fed4f78221faa7898ab4f928ca3b6e967790eeffb293

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a6a51c65705334771c21fed4f78221faa7898ab4f928ca3b6e967790eeffb293",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider
    }
  }
};

export default node;
